/** 判断是否在微信浏览器中 */
export function isWeixin() {
  const ua = navigator.userAgent.toLowerCase()
  return /micromessenger/.test(ua)
}

/** 获取 cookie */
export function getCookie(name) {
  const all = document.cookie
  const pos = all.indexOf(name)
  if (pos === -1) return ''
  const start = pos + name.length + 1
  const end = all.indexOf(';', start)
  return decodeURIComponent(all.substring(start, end === -1 ? all.length : end))
}

/** 设置 cookie */
export function setCookie(name, value, days = 7) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString()
  document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires};path=/`
}

/** 获取 URL 中的 OAuth code 参数 */
export function getUrlCode() {
  const search = location.search
  const match = search.match(/[?&]code=([^&]+)/)
  return match ? match[1] : null
}

/** 构建微信 OAuth 跳转链接（需公众号后台配置授权域名后使用）*/
export function buildOAuthUrl(appid = 'wx4a9f2dde11ff7d54') {
  const redirectUri = encodeURIComponent(location.href.split('#')[0])
  return (
    `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}` +
    `&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`
  )
}

/** 验证中国身份证号 */
export function isChinaIDCard(str) {
  const reg = /^[1-9]\d{5}(19|20)\d{2}(0\d|1[0-2])([012]\d|3[01])\d{3}[0-9X]$/
  if (!reg.test(str)) return false
  const nums = str.split('')
  let total = 0
  for (let i = 0; i < 17; i++) {
    total += parseInt(nums[i], 10) * ((Math.pow(2, 17 - i)) % 11)
  }
  let last = (12 - (total % 11)) % 11
  if (last === 10) last = 'X'
  return last.toString() === nums[17].toUpperCase()
}

/** 调用微信 JSAPI 支付 */
function jsApiCall(json, onSuccess, onFail) {
  window.WeixinJSBridge.invoke(
    'getBrandWCPayRequest',
    {
      appId: json.appId,
      timeStamp: json.timeStamp,
      nonceStr: json.nonceStr,
      package: json.package,
      signType: json.signType,
      paySign: json.paySign,
    },
    function (res) {
      if (res.err_msg === 'get_brand_wcpay_request:ok') {
        onSuccess && onSuccess(res)
      } else {
        onFail && onFail(res)
      }
    }
  )
}

/** 发起微信支付 */
export function callpay(json, onSuccess, onFail) {
  if (typeof window.WeixinJSBridge === 'undefined') {
    const handler = () => jsApiCall(json, onSuccess, onFail)
    if (document.addEventListener) {
      document.addEventListener('WeixinJSBridgeReady', handler, false)
    } else if (document.attachEvent) {
      document.attachEvent('WeixinJSBridgeReady', handler)
    }
  } else {
    jsApiCall(json, onSuccess, onFail)
  }
}
